module.exports = __webpack_public_path__ + "static/media/firstPageIcon.90e2e81f.svg";